export default {
  type: 'code',
  title: `Code`,
  icon: `pencil`,
  template: `<div
               contenteditablebind
               contenteditable="true"
               feature-obj="feature"
               org-index="orgIndex"
               class="code-editor"
             >
               <textarea 
                 data-mode="{{feature.language}}"
                 class="code ignore-enter" 
                 ng-value="feature.content" 
                 ng-model="feature.content" 
                 value="{{feature.content}}">
               </textarea>
             </div>`,
  propertyTemplate: `<div class="form-group row">
                       <label>Code Language</label>
                       <input
                         type="text"
                         class="form-control"
                         ng-model="feature.language" />
                     </div>`,
  customHandleButtons: [
    {
      className: 'fa fa-caret-square-o-up btnShowAll',
      event: 'show-all',
      tooltip: 'Show/hide all markup',
    },
  ],
}
